var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { findDOMNode } from 'react-dom';
import { action, observable, makeObservable } from 'mobx';
import { AspectMountComponent } from './AspectMountComponent';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { AspectMountMeasureDom } from './AspectMountMeasureDom';
import { AspectMountMeasureToWindow } from './AspectMountMeasureToWindow';
import { AspectMountMeasureToInnerStage } from './AspectMountMeasureToInnerStage';
import { AspectMountDimensions } from './AspectMountDimensions';
import { runtime } from '../../../runtime/Runtime';
import { MeasureType } from '../../../learnware/LearnwareEnums';
export class AspectMount {
    parent;
    constructor(parent, reactInstance = null) {
        makeObservable(this);
        this.parent = parent;
        this.Aspect__ = reactInstance;
    }
    Aspect__;
    isClone = false;
    get aspect() {
        return this.parent;
    }
    get mountComponent() {
        return new AspectMountComponent(this);
    }
    get measureDom() {
        return new AspectMountMeasureDom(this);
    }
    get measureToWindow() {
        return new AspectMountMeasureToWindow(this, MeasureType.OffsetToPage);
    }
    get measureToInnerStage() {
        return new AspectMountMeasureToInnerStage(this, MeasureType.OffsetToPage);
    }
    get measureToWindowIncludingTransform() {
        return new AspectMountMeasureToWindow(this, MeasureType.BoundingClientRect);
    }
    get measureToInnerStageIncludingTransform() {
        return new AspectMountMeasureToInnerStage(this, MeasureType.BoundingClientRect);
    }
    get mountDimensions() {
        return new AspectMountDimensions(this);
    }
    // domElement_plain: null | Element | Text;
    domElement_observable;
    domElement_lazy;
    get domElement() {
        return this.domElement_observable || this.domElement_lazy;
    }
    get isOutermostMountedAspectOfActor() {
        return this.aspect.actor.actorMounted.outermostRenderedAspect === this.aspect;
    }
    setDomNode(el = findDOMNode(this.Aspect__)) {
        if (this.domElement_observable === el)
            return;
        this.domElement_observable = el; // quick recalculation of width and rerender
        //   this.domElement_plain = el;
        this.measureDom.setupObservers(el);
        if (el) {
            el.aspect = this.aspect;
        }
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            this.domElement_lazy = el;
            if (el) {
                runtime.runtimeScheduler.addToNextIdleStateChange(() => {
                    if (!!el.closest && !!el.closest('.isClone')) {
                        this.isClone = true;
                    }
                });
            }
        });
    }
}
__decorate([
    observable
], AspectMount.prototype, "isClone", void 0);
__decorate([
    memoize
], AspectMount.prototype, "mountComponent", null);
__decorate([
    memoize
], AspectMount.prototype, "measureDom", null);
__decorate([
    memoize
], AspectMount.prototype, "measureToWindow", null);
__decorate([
    memoize
], AspectMount.prototype, "measureToInnerStage", null);
__decorate([
    memoize
], AspectMount.prototype, "measureToWindowIncludingTransform", null);
__decorate([
    memoize
], AspectMount.prototype, "measureToInnerStageIncludingTransform", null);
__decorate([
    memoize
], AspectMount.prototype, "mountDimensions", null);
__decorate([
    observable.ref
], AspectMount.prototype, "domElement_observable", void 0);
__decorate([
    observable.ref
], AspectMount.prototype, "domElement_lazy", void 0);
__decorate([
    action.bound
], AspectMount.prototype, "setDomNode", null);
